import api from './apiClient';

export const discountsAPI = {
  getAllDiscounts: async () => {
    const response = await api.get('/api/discounts');
    return response.data;
  },
  getDiscounts: async (raceId) => {
    const response = await api.get(`/api/races/${raceId}/discounts`);
    return response.data;
  },
  createDiscount: async (raceId, discountData) => {
    const response = await api.post(`/api/races/${raceId}/discounts`, discountData);
    return response.data;
  },
  updateDiscount: async (id, discountData) => {
    const response = await api.post(`/api/discounts/${id}`, discountData);
    return response.data;
  },
  deleteDiscount: async (id) => {
    await api.post(`/api/discounts/${id}/delete`, {});
  },
  validateDiscount: async (data) => {
    const response = await api.post('/api/discounts/validate', data);
    return response.data;
  },
};
